/*
  Catalog preview (PDP LAB, 19 Sep 2026). Hovering or focusing a menu link crossfades the
  preview on the right to that collection: photo, name, piece count, and the card links there.
  Leaving the link list returns it to the resting promo. Two stacked images so the swap never
  flashes; photos are fetched the first time the menu opens.
*/
(() => {
  const bind = (panel) => {
    if (panel.dataset.bound) return;
    panel.dataset.bound = '1';
    const inner = panel.closest('.mega-menu__inner');
    const card = panel.querySelector('[data-kn-mp-card]');
    const imgs = [...panel.querySelectorAll('.kn-mp__img')];
    const title = panel.querySelector('[data-kn-mp-title]');
    const meta = panel.querySelector('[data-kn-mp-meta]');
    const links = [...inner.querySelectorAll('[data-kn-preview]')];
    let front = 0;
    let current = card.dataset.defaultSrc;

    const show = (src, t, m, href) => {
      if (src && src !== current) {
        const back = imgs[1 - front];
        back.onload = () => {
          back.classList.add('is-on');
          imgs[front].classList.remove('is-on');
          front = 1 - front;
        };
        back.src = src;
        current = src;
      }
      title.textContent = t;
      meta.textContent = m;
      card.href = href;
    };
    const rest = () => show(card.dataset.defaultSrc, card.dataset.defaultTitle, card.dataset.defaultMeta, card.dataset.defaultHref);

    links.forEach((a) => {
      const go = () => show(a.dataset.knPreview, a.dataset.knTitle, a.dataset.knMeta, a.href);
      a.addEventListener('mouseenter', go);
      a.addEventListener('focus', go);
    });
    inner.querySelector('.mega-menu__list')?.addEventListener('mouseleave', rest);

    const details = panel.closest('details');
    details?.addEventListener('toggle', () => {
      if (!details.open || panel.dataset.warm) return;
      panel.dataset.warm = '1';
      links.forEach((a) => { const i = new Image(); i.src = a.dataset.knPreview; });
    });
  };
  const init = () => document.querySelectorAll('[data-kn-mp]').forEach(bind);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
